










































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import { UserService } from "@/service/UserService";
import { Utils } from "@/service/util";
import { MESSAGE } from "@/model/Message";
import ButtonInspectResult from "@/components/common/button/ButtonInspectResult.vue";
import Number from "@/shared/filters/Number";

export interface SideTab {
  title1: string;
  title2: string;
  router: string;
  priceDisp: number | 0;
  priceSub: number | 0;
  confirm: number | 0;
  calcLabel: string;
  isActive: boolean | false;
  isConfirm: boolean | false;
  tabId: number;
  lock: string;
  mode: string;
}

@Component({
  components: {
    InputNumber
  },
  filters: {
    Number
  }
})

export default class QuickSideTabRight extends Vue {
  // @Prop() totalRecommend: any;
  @Prop() totalCoupon: any;
  @Prop() totalShohiyou: any;
  @Prop() selectTabNum: number;

  @Getter("sideTabListQuick", { namespace: "FunctionSetting" })
  sideTabListQuick: any;

  totalRecommend: any = { totalZk: 0, totalZn: 0 };
  // totalShohiyou: any = { totalZk: 0, totalZn: 0 };
  // totalCoupon: any = { subTotalZk: 0, subTotalZn: 0 };
  stateId: number = 1;
  isConfirmRecommend: number = 0;
  isConfirmPayment: number = 0;
  isConfirmShohiyou: number = 0;

  sideTab: SideTab[] = [];

  sumLegal56: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  sumRecommend: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  hasBtn: boolean = false;

  isOnPlus = [false, false, false, false];

  public utils: Utils = new Utils();

  @Watch('selectTabNum')
  onChangeSelectTab() {
    this.onActive(this.sideTab[this.selectTabNum].router);
  }

  created() {
    // console.log("QuickSideTabRight.created => START!!", this.totalCoupon);
    if (this.$route.name == "userquickmitsumori") {
      this.hasBtn = false;
    } else {
      this.hasBtn = true;
    }

    this.sideTabListQuick.forEach((sub: any) => {
      let tab: SideTab = {
        title1    : sub.title1,
        title2    : sub.title2,
        router    : sub.router,
        priceDisp : 0,
        priceSub  : 0,
        confirm   : 0,
        calcLabel : sub.calcLabel,
        isActive  : false,
        isConfirm : false,
        tabId     : sub.tabId,
        lock      : sub.lock,
        mode      : sub.mode
      };

      this.sideTab.push(tab);
    });
  }

  setSumRecommend() {
    // this.$set(this, "sumRecommend", this.sumPrice(INSPECT_TYPE.RECOMMEND));
  }

  totalAllZn: number = 0;
  totalAllZk: number = 0;
  totalCalcZk: number = 0;

  get sum() {
    this.totalCalc();
    return this.totalAllZk;
  }

  totalCalc() {

    // 税抜き
    this.$set(this, "totalAllZn",
        this.totalShohiyou.totalZn
      +this.totalCoupon.subTotalZn
      +this.totalRecommend.totalZn
    );

    // 税込み
    this.$set(this, "totalAllZk",
        this.totalShohiyou.totalZk
      +this.totalCoupon.subTotalZk
      +this.totalRecommend.totalZk
    );

    this.sideTab[0].priceDisp = this.totalShohiyou.totalZk;
    this.sideTab[0].priceSub = this.totalShohiyou.totalZn;
    this.sideTab[0].confirm = this.isConfirmShohiyou;

    this.sideTab[1].priceDisp = this.totalCoupon.subTotalZk;
    this.sideTab[1].priceSub = this.totalCoupon.subTotalZn;
    this.sideTab[1].confirm = this.totalCoupon.isConfirm;
    // this.sideTab[1].priceSub2 = sumPriceLegal56.totalZn; // 構造の問題で格納できない

    this.sideTab[2].priceDisp = this.totalRecommend.totalZk;
    this.sideTab[2].priceSub = this.totalRecommend.totalZn;
    this.sideTab[2].confirm = this.isConfirmRecommend;

    this.sideTab[3].priceDisp = 0;
    this.sideTab[3].priceSub = 0; // totalAllZk
    this.sideTab[3].confirm = this.isConfirmPayment;
  }

  onActive(key: string) {
    this.sideTab.forEach((tab: any, i: number) => {
      if (tab.router == key) {
        tab.isActive = true;
      } else {
        tab.isActive = false;
      }
    });
  }

  onSelect(key: string) {
    this.sideTab.forEach((tab: any, i: number) => {
      if (tab.router == key) {
        this.onActive(tab.router);
        if (i <= 1) { // 2,3は処理しない
          this.$router.push({ name: tab.router });
        }
      }
    });
  }

  onConfirm(key: string) {
    this.sideTab.forEach((tab: any, i: number) => {
      if (tab.router == key) {
        tab.isConfirm = true;
        this.onUpdate(tab.router);
      }
    });
  }

  onUpdate(key: string) {
    // if (index == 2) {
    //   this.setSumPriceLegal56();
    // } else if (index == 3) {
    //   this.setSumRecommend();
    // }
  }

  isConfirm(flag: number) {
    return flag == 1;
  }

  textConfirm(flag: number) {
    return flag ? "確" : "未";
  }

  onPlus(index: number, event: any) {
    event.stopPropagation();
    this.$set(this.isOnPlus, index, !this.isOnPlus[index]);
  }

  gotoMitusmori() {
    this.$router.push({ name: "userquickmitsumori" });
  }

  get isActiveInspectCost() {
    return this.sideTab[0].isActive;
  }
}
